<div style="max-width: 600px">
  <mat-dialog-content>
    <lemon-dialog-header> Uuden sopimuksen julkaiseminen </lemon-dialog-header>

    <div style="margin-top: 2em; padding-left: 1em; padding-right: 1em">
      <p style="font-weight: 500; margin-bottom: 1em">Lataa PDF-template:it ennen julkaisua</p>

      <!-- Suomenkielinen templaatti -->
      <div style="display: flex; align-items: center; gap: 1em; margin-bottom: 1em">
        <input type="file" accept=".pdf" style="display: none" #fiInput (change)="onTemplateFileChange('fi', $event)" />
        <app-primary-button (click)="fiInput.click()" actionId="Lataa suomenkielinen sopimus-PDF-templaatti" [disabled]="fiTemplateStatus() === 'uploading'"> Suomenkielinen (FI) </app-primary-button>
        @if (fiTemplateStatus() === 'uploading') {
          <mat-spinner [diameter]="24"></mat-spinner>
        }
        @if (fiTemplateStatus() === 'valid') {
          <mat-icon style="color: green">check_circle</mat-icon>
        }
        @if (fiTemplateStatus() === 'error') {
          <span style="display: flex; align-items: center; gap: 0.5em; color: red"> </span>
        }
      </div>

      <!-- Englanninkielinen templaatti -->
      <div style="display: flex; align-items: center; gap: 1em">
        <input type="file" accept=".pdf" style="display: none" #enInput (change)="onTemplateFileChange('en', $event)" />
        <app-primary-button (click)="enInput.click()" actionId="Lataa englanninkielinen sopimus-PDF-templaatti" [disabled]="enTemplateStatus() === 'uploading'"> Englanninkielinen (EN) </app-primary-button>
        @if (enTemplateStatus() === 'uploading') {
          <mat-spinner [diameter]="24"></mat-spinner>
        }
        @if (enTemplateStatus() === 'valid') {
          <mat-icon style="color: green">check_circle</mat-icon>
        }
        @if (enTemplateStatus() === 'error') {
          <span style="display: flex; align-items: center; gap: 0.5em; color: red"> </span>
        }
      </div>
    </div>
    @if (commonError()) {
      <div class="error-text">{{ commonError() }}</div>
    }
  </mat-dialog-content>
  <mat-dialog-actions style="justify-content: space-evenly; padding-left: 3em; padding-right: 3em">
    <app-primary-button (click)="peruta()" actionId="Varmistus: Peruuta käyttöehtojen julkaisu" mat-dialog-close>Peruuta</app-primary-button>
    <app-secondary-button (click)="julkaise()" actionId="Varmistus: Julkaise käyttöehdot" [disabled]="!julkaiseEnabled()">Julkaise</app-secondary-button>
  </mat-dialog-actions>
</div>
